export type { SEOHeadProps } from './SEOHead';
export { default } from './SEOHead';
